'use client'
import { SignUp } from "@clerk/nextjs"
import { useTheme } from 'next-themes'
import { useEffect } from 'react'
import { logger } from '@/lib/logger'
import { useSearchParams } from 'next/navigation'
import { useLocalStorage } from '@/lib/hooks/use-local-storage'

export default function SignUpPage() {
  const { setTheme } = useTheme()
  const [storedInvitation] = useLocalStorage<{
    invitationId: string;
    organizationId: string;
    orgSlug: string;
  } | null>('mixus_org_invitation', null)

  useEffect(() => {
    setTheme('light')
  }, [setTheme])

  const [currentReferral, setCurrentReferral] = useLocalStorage<string | null>('mixus_ref', null)
  const [currentTeamInviteId, setCurrentTeamInviteId] = useLocalStorage<string | null>('mixus_teamInviteId', null)

  // Safe URL params access
  const getUrlParam = (param: string): string | null => {
    try {
      if (typeof window !== 'undefined') {
        return new URLSearchParams(window.location.search).get(param)
      }
      return null
    } catch (e) {
      logger.warn(`URL params access failed:${e}`)
      return null
    }
  }

  const referral = getUrlParam('ref')
  const teamInviteId = getUrlParam('teamInviteId')

  useEffect(() => {
    if (referral) setCurrentReferral(referral)
    if (teamInviteId) setCurrentTeamInviteId(teamInviteId)
  }, [referral, teamInviteId, setCurrentReferral, setCurrentTeamInviteId])

  // Then use stored values
  console.log(`[Referred By] ${currentReferral}`)
  console.log(`[Team Invitation ID] ${currentTeamInviteId}`)

  const redirectUrl = new URLSearchParams()
  redirectUrl.append('onboard', 'true')
  if (currentReferral) redirectUrl.append('ref', currentReferral)
  if (currentTeamInviteId) redirectUrl.append('teamInviteId', currentTeamInviteId)

  const finalRedirectUrl = storedInvitation ? 
    `/organization-join?invitation_id=${storedInvitation.invitationId}&organization_id=${storedInvitation.organizationId}${storedInvitation.orgSlug ? `&org=${storedInvitation.orgSlug}` : ''}` :
    `/organizations${redirectUrl.toString() ? `?${redirectUrl.toString()}` : ''}`

  return (
    <div className="py-10">
      <div className="flex flex-col items-center gap-4 space-y-3">
        <SignUp
          appearance={{
            variables: {
              colorBackground: 'transparent',
            },
            elements: {
              card: {
                border: '0px',
                boxShadow: 'none'
              },
              cardBox: {
                border: '0px',
                boxShadow: 'none'
              },
              headerTitle: "text-xl font-bold text-center text-foreground mb-2",
              headerSubtitle: "text-sm text-center text-muted-foreground max-w-md mb-4",
              footer: {
                background: 'none',
                borderTop: '0px',
              },
              socialButtons: {
                background: "white"
              }
            },
          }}
          signInUrl="/sign-in"
          path="/sign-up"
          afterSignUpUrl={finalRedirectUrl}
          redirectUrl={finalRedirectUrl}
        />
      </div>
    </div>
  )
}
